import { useEffect } from 'react';
import { Language } from '@/lib/i18n';
import { setCanonicalAndHreflang } from '@/lib/seo';

const meta: Record<Language, { title: string; description: string; ogTitle: string; ogDescription: string; lang: string }> = {
  en: {
    title: 'Dr.Vet AI | Scientific Veterinary Assistant — Invest in the Future',
    description: 'Research-backed AI for veterinary clinics. Automatic medical record entries and global scaling. Proven in wartime Ukraine. Presenting at WVAC 2026 Tokyo (21–24 April).',
    ogTitle: 'Dr.Vet AI | Scientific Veterinary Assistant — Invest in the Future',
    ogDescription: 'Research-backed AI for veterinary clinics. Automatic medical record entries and global scaling. Proven in wartime Ukraine. Presenting at WVAC 2026 Tokyo (21–24 April). Backed by University of Hertfordshire research and real clinic data.',
    lang: 'en',
  },
  uk: {
    title: 'Dr.Vet AI | Науковий ветеринарний асистент — Інвестуйте в майбутнє',
    description: 'AI для ветеринарних клінік на основі наукових досліджень. Автоматичне ведення медичних записів та глобальне масштабування. Перевірено в умовах війни в Україні. Доповідь на WVAC 2026 Токіо (21–24 квітня).',
    ogTitle: 'Dr.Vet AI | Науковий ветеринарний асистент — Інвестуйте в майбутнє',
    ogDescription: 'AI для ветеринарних клінік на основі наукових досліджень. Автоматичне ведення медичних записів та глобальне масштабування. Перевірено в умовах війни в Україні. Доповідь на WVAC 2026 Токіо.',
    lang: 'uk',
  },
  ja: {
    title: 'Dr.Vet AI | 科学に基づく獣医AIアシスタント — 未来への投資',
    description: '研究に裏打ちされた獣医クリニック向けAI。自動医療記録入力とグローバル展開。ウクライナの戦時下で実証済み。WVAC 2026 東京（4月21〜24日）にて発表。',
    ogTitle: 'Dr.Vet AI | 科学に基づく獣医AIアシスタント — 未来への投資',
    ogDescription: '研究に裏打ちされた獣医クリニック向けAI。自動医療記録入力とグローバル展開。ウクライナの戦時下で実証済み。WVAC 2026 東京にて発表。ハートフォードシャー大学の研究と実際のクリニックデータに基づく。',
    lang: 'ja',
  },
};

function setMetaContent(selector: string, content: string) {
  const el = document.querySelector(selector);
  if (el) el.setAttribute('content', content);
}

export function useDocumentMeta(lang: Language) {
  useEffect(() => {
    const m = meta[lang];
    document.title = m.title;
    document.documentElement.lang = m.lang;
    setMetaContent('meta[name="description"]', m.description);
    setMetaContent('meta[property="og:title"]', m.ogTitle);
    setMetaContent('meta[property="og:description"]', m.ogDescription);
    setMetaContent('meta[name="twitter:title"]', m.ogTitle);
    setMetaContent('meta[name="twitter:description"]', m.ogDescription);
    setCanonicalAndHreflang('/', lang);
  }, [lang]);
}
